import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
    <p><strong>Description</strong></p>
    <p>
      This action contains <strong>trend</strong> data for the past 24 hours highlighting where social distancing can be
      improved. The intent of this data is to provide insights to on-site leadership teams to assist them in identifying
      areas
      in which they need to increase their focus, this data cannot be used for corrective action.
    </p>
    <p>&nbsp;</p>
    <p><strong>Resolution Steps</strong></p>
    <ol>
      <li>Identify the top locations for social distancing opportunity, located in "Action Details".</li>
      <li>
        If needed, the <span className="wikiinternallink"><a href="https://pe.corp.amazon.com/covid_sd">PETS Proxemics Dashboard</a></span> can
        be used to further deep dive.
      </li>
      <li>Use this data to identify gaps and improve existing auditing strategy, or create a plan for manager coverage.</li>
      <li>Close out action.</li>
    </ol>
    <p>
      A training on how to interpret and action the report can be viewed <span className="wikiinternallink"><a
      href="https://w.amazon.com/bin/view/ManagersReferenceGuide/ATLAS/ActionCenter/SocialDistancing">here</a></span>.
    </p>
    <div className="wikimodel-emptyline"></div>
    <p><strong>Supplemental Links</strong></p>
    <p>
      1) <span className="wikiinternallink"><a rel=" noopener noreferrer" target="_blank"
                                               href="https://pe.corp.amazon.com/covid_sd">PETS Proxemics Dashboard</a></span>
    </p>
    <p>
      2) <span className="wikiinternallink"><a rel=" noopener noreferrer" target="_blank"
                                               href="https://w.amazon.com/bin/view/Proxemics/Camera_requests/">Camera requests</a></span>
    </p>
    <p>
      3) <span className="wikiinternallink"><a rel=" noopener noreferrer" target="_blank"
                                               href="https://w.amazon.com/bin/view/ManagersReferenceGuide/ATLAS/ActionCenter/SocialDistancing/#HFAQ:">FAQ</a></span>
    </p>
    <p>
      4) <span className="wikiinternallink"><a rel=" noopener noreferrer" target="_blank"
                                               href="https://issues.amazon.com/issues/create?template=0b8ae5cb-30f8-4ccf-b965-a13e4121cf93">Permissions Requests</a></span>
    </p>
  </div>`
);


// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_SD_Trend.jsx